import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=26fb6688&scoped=true&"
import script from "./NotificationsButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=26fb6688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb6688",
  null
  
)

export default component.exports